import React, {useState, useEffect, useContext, useRef} from 'react';
import {TableWrapperContext} from './TableWrapper';
import css from '../../../styles/FacebookStatistics.module.scss';
import classNames from 'classnames';
import {useStore} from '../../../store/store';
import {observer} from 'mobx-react';
import {TrekerButton} from '../../pages/traffic/influence/bloggers/source/Treker/TrekerButton';
import {CreateAppModal} from '../../../_metronic/partials';
import {useResolvedThemeMode} from '../../hooks/useResolvedThemeMode';
import {copyText} from '../../functions/copyText';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

const Presets = () => {
  const store = useStore();
  const theme = useResolvedThemeMode();

  const {
    link,
    presetId,
    localPresetId,
    presets,
    setPresets,
    activatePreset,
    presetData,
    objectToQueryString,
    activePreset,
    setActivePreset,
  } = useContext(TableWrapperContext);

  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [name, setName] = useState('');

  const [error, setError] = useState(false);

  return (
    <>
      <OverlayTrigger
        delay={{hide: 450, show: 300}}
        placement='top'
        overlay={(props) => (
          <Tooltip className='fs-8' {...props}>
            Создание присетов
          </Tooltip>
        )}
      >
        <div>
          <TrekerButton
            svg={<i className='bi bi-sliders fs-2 text-gray-600'></i>}
            style={{
              height: '40px',
              gap: '0',
              backgroundColor: theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
            }}
            onClick={() => {
              setShowCreateAppModal(true);
            }}
          />
        </div>
      </OverlayTrigger>
      <OverlayTrigger
        delay={{hide: 450, show: 300}}
        placement='top'
        overlay={(props) => (
          <Tooltip className='fs-8' {...props}>
            Скопировать текущие настройки
          </Tooltip>
        )}
      >
        <div>
          <TrekerButton
            svg={<i className='bi bi-link-45deg fs-2 text-gray-600'></i>}
            style={{
              height: '40px',
              gap: '0',
              backgroundColor: theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
            }}
            onClick={() => {
              copyText(`${link}?${objectToQueryString(presetData)}`);
            }}
          />
        </div>
      </OverlayTrigger>
      <CreateAppModal
        customWidth='mw-600px'
        padding='pb-lg-10 pt-lg-10 px-lg-10'
        show={showCreateAppModal}
        handleClose={() => setShowCreateAppModal(false)}
        title={'Присеты'}
      >
        <div className={css.presets}>
          <div className={css.form}>
            <input
              className={`form-control form-control-lg form-control-solid ${
                !!error ? 'is-invalid' : ''
              }`}
              placeholder='Название присета'
              value={name || ''}
              onChange={(e) => {
                const findDuplicateIndex = presets.findIndex(
                  (item) => item.name === e.target.value.trim()
                );
                if (findDuplicateIndex === -1) {
                  setError(false);
                } else {
                  setError(true);
                }
                setName(e.target.value);
              }}
            />
            <TrekerButton
              svg={
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  fill='currentColor'
                  className='bi bi-floppy'
                  viewBox='0 0 16 16'
                >
                  <path d='M11 2H9v3h2z' />
                  <path d='M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z' />
                </svg>
              }
              style={{
                height: '45px',
                minWidth: '45px',
                gap: '0',
                backgroundColor:
                  theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
              }}
              disabled={error || !name}
              onClick={async () => {
                const objForUrl = structuredClone(presetData);
                delete objForUrl.name;
                delete objForUrl.table_id;
                delete objForUrl.url;
                delete objForUrl.id;
                const addPreset = await store.requestPost('statistics/presets', {
                  data: {name, url: objectToQueryString(objForUrl), table_id: presetId},
                  preloader: false,
                });
                setPresets((prev) => [...prev, addPreset]);
              }}
            />
            {error && (
              <div class='invalid-feedback' style={{display: 'block'}}>
                Присет с таким названием уже существует
              </div>
            )}
          </div>
          <div className={css.listContainer}>
            <span className={classNames(css.listTitle, 'text-gray-600')}>
              Список созданых приcетов
            </span>
            <ul className={css.list}>
              {presets
                .sort((a, b) => b.created - a.created)
                .map((item, index) => {
                  return (
                    <li className={css.item} key={`${item?.name}-${index}`}>
                      <div className='form-check form-switch form-check-custom form-check-solid'>
                        <input
                          className='form-check-input h-30px w-50px cursor-pointer'
                          type='checkbox'
                          checked={activePreset === item.id}
                          onChange={(e) => {
                            if (item.id === activePreset) {
                              activatePreset(localStorage.getItem(localPresetId) || '');
                              localStorage.setItem(presetId, null);
                              setActivePreset(null);
                            } else {
                              activatePreset(item.url);
                              localStorage.setItem(presetId, JSON.stringify(item));
                              setActivePreset(item.id);
                            }
                          }}
                        />
                      </div>
                      <div
                        className={css.nameContainer}
                        style={{
                          backgroundColor:
                            theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
                        }}
                      >
                        <span>{item.name}</span>
                      </div>
                      <TrekerButton
                        svg={<i className='bi bi-link-45deg fs-2 text-gray-600'></i>}
                        style={{
                          height: '40px',
                          minWidth: '40px',
                          gap: '0',
                          backgroundColor:
                            theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
                        }}
                        onClick={() => {
                          copyText(`${link}?${item.url}`);
                        }}
                      />
                      <TrekerButton
                        svg={<i className='ki-outline ki-basket fs-2 text-danger'></i>}
                        style={{
                          height: '40px',
                          minWidth: '40px',
                          gap: '0',
                          backgroundColor:
                            theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
                        }}
                        onClick={async () => {
                          await store.requestDelete('statistics/presets', {
                            data: {id: item.id},
                            preloader: false,
                          });
                          const newPresets = [...presets];
                          const findIndex = newPresets.findIndex((el) => el.id === item.id);
                          newPresets.splice(findIndex, 1);
                          setPresets(newPresets);
                        }}
                      />
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </CreateAppModal>
    </>
  );
};

export default observer(Presets);
